import { useEffect, useState } from 'react';
import api from '../services/api';
import {
  LuBuilding,
} from 'react-icons/lu';

// Mostra um seletor de "empresa ativa" apenas quando o backend retorna mais
// de uma empresa acessível para o usuário logado (GET /companies já vem
// escopado: superadmin vê todas, admin de matriz vê a própria + filiais,
// qualquer outro só vê 1 — nesse último caso o componente não renderiza
// nada). A empresa escolhida é salva em localStorage e enviada em toda
// requisição como o header X-Active-Company-Id (ver services/api.js).
export default function CompanySwitcher() {
  const [companies, setCompanies] = useState(null); // null = ainda carregando

  useEffect(() => {
    let mounted = true;
    // Sempre busca o conjunto COMPLETO de empresas acessíveis, ignorando
    // qualquer empresa ativa já selecionada — senão, ao escolher uma filial
    // específica, essa mesma busca voltaria só 1 empresa e o seletor
    // desapareceria (companies.length <= 1), prendendo o usuário nela.
    api.get('/companies', { headers: { 'X-Active-Company-Id': '' } })
      .then(({ data }) => { if (mounted) setCompanies(Array.isArray(data) ? data : []); })
      .catch(() => { if (mounted) setCompanies([]); });
    return () => { mounted = false; };
  }, []);

  if (!companies || companies.length <= 1) return null;

  const activeId = localStorage.getItem('activeCompanyId') || '';

  const handleChange = (e) => {
    const value = e.target.value;
    if (value) {
      localStorage.setItem('activeCompanyId', value);
    } else {
      localStorage.removeItem('activeCompanyId');
    }
    window.location.reload();
  };

  return (
    <div className="company-switcher" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <LuBuilding color="var(--text-3)" size={14} />
      <select
        value={activeId}
        onChange={handleChange}
        title="Empresa ativa"
        style={{
          padding: '6px 10px',
          border: '1px solid var(--border)',
          borderRadius: 8,
          fontSize: 13,
          fontFamily: 'inherit',
          color: 'var(--text-1)',
          background: 'var(--surface-1)',
          cursor: 'pointer',
        }}
      >
        <option value="">Todas as empresas</option>
        {companies.map((c) => (
          <option key={c.id} value={c.id}>{c.trade_name || c.name}</option>
        ))}
      </select>
    </div>
  );
}
